import { RefreshIcon } from "@heroicons/react/outline";
import { useContext, useState } from "react";
import { postData } from "../backend";
import { WorkflowContext } from "../contexts";
import GuidesButton from "./GuidesButton";
import { useTranslation } from "react-i18next";

function WorkflowAutomationPanelIncomplete() {
  const { t } = useTranslation();
  const { workflow, mutateWorkflow } = useContext(WorkflowContext);

  const [isRefreshing, setIsRefreshing] = useState(false);

  function handleRefreshValidation() {
    setIsRefreshing(true);
    postData(`/workflows/${workflow.id}/validate/`)
      .then(() => mutateWorkflow())
      .catch(console.error)
      .finally(() => setIsRefreshing(false));
  }

  if (workflow.status === "COMPLETE")
    return null;

  return (
    <div className="flex flex-col items-center gap-2 pt-4">
      <div className="text-yellow font-semibold text-sm w-full">
        {t("Your workflow must be complete before you can start an automation")}
      </div>
      {workflow.incompleteReasons?.length > 0 && (
        <ul className="text-sm text-gray-600 list-disc list-outside pl-3 w-full">
          {workflow.incompleteReasons.map((reason, i) => (
            <li key={i}>{reason}</li>
          ))}
        </ul>
      )}
      <div className="flex items-center justify-evenly w-full gap-2">
        <GuidesButton />
        <button className="flex items-center gap-1 font-gilroy text-sm font-semibold hover:underline my-auto text-gray-400 hover:text-blue cursor-pointer" onClick={handleRefreshValidation} disabled={isRefreshing}>
          <RefreshIcon className={`w-4 h-4 ${isRefreshing ? "animate-spin" : ""}`} />
          {t("Revalidate")}
        </button>
      </div>
    </div>
  );
}

export default WorkflowAutomationPanelIncomplete;
